import { WebhooksSettingsPage } from '../settings/Webhooks';

export function WebhooksAdminPage() {
  return <WebhooksSettingsPage />;
}
